import { render } from "./DataTableOptimized.vue?vue&type=template&id=631fbd87"
import script from "./DataTableOptimized.vue?vue&type=script&lang=js"
export * from "./DataTableOptimized.vue?vue&type=script&lang=js"

import "./DataTableOptimized.vue?vue&type=style&index=0&id=631fbd87&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__